import { create } from "zustand";
import { persist,createJSONStorage  } from "zustand/middleware";

const useAuthStore = create(
  persist(
    (set) => ({
  // ----- STATE -----
  inputUserName: null,
  user: null,
  role: null,
  displayUserName: "",
  category: null,
  isAuthenticated: false,
  isMfaRequired: false,
  showMfaImage: false,
  isLoading: false,
  error: null,
  token: "",
  userLastLogin: null,
  sessionExpired: false,
  forbiddenAccess: false,

  // ----- ACTIONS -----
   setUserLastLogin: (lastLogin) => 
    set({
      userLastLogin: lastLogin
    }),
  setDisplayUserName: (name) => 
    set({
      displayUserName: name
    }),
  setInputUserName: (username) => 
    set({
      inputUserName: username
    }),
  setUser: (user) =>
    set({
      user:user.userid,
      role:user.roleid,
      category: user.categoryid
    }),
  setToken: (responseToken) =>
    set({
        token: responseToken
    }),

  requireMfa: (status) =>
    set({
      isMfaRequired: status,
    }),
  setShowMfaImage: (status) =>
    set({
      showMfaImage: status
    }),

  setLoading: (loading) =>
    set({
      isLoading: loading,
    }),

  setError: (error) =>
    set({
      error,
    }),

  showSessionExpired: () => set({ sessionExpired: true }),
  hideSessionExpired: () => set({ sessionExpired: false }),
  showForbiddenAccess: () => set({ forbiddenAccess: true }),
  hideForbiddenAccess: () => set({ forbiddenAccess: false }),

  logout: () =>
    set({
      inputUserName: null,
      user: null,
      role: null,
      category: null,
      displayUserName: "",
      userLastLogin: null,
      showMfaImage: false,
      token: "",
      isAuthenticated: false,
      isMfaRequired: false,
      isLoading: false,
      error: null,
    }),
}),
{
      name: "auth-storage",
      storage: createJSONStorage(() => localStorage),
    }
  ),
);

export default useAuthStore;
